import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const badges = [
    {
      icon: 'Shield',
      label: 'HIPAA Compliant',
      color: 'var(--color-success)'
    },
    {
      icon: 'Lock',
      label: 'SSL Encrypted',
      color: 'var(--color-primary)'
    },
    {
      icon: 'CheckCircle',
      label: 'Healthcare Certified',
      color: 'var(--color-secondary)'
    }
  ];

  return (
    <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 lg:gap-8">
      {badges?.map((badge, index) => (
        <div 
          key={index}
          className="flex items-center gap-2 px-3 py-2 md:px-4 md:py-2.5 bg-muted rounded-lg transition-smooth hover:shadow-elevation-2"
        >
          <Icon name={badge?.icon} size={16} color={badge?.color} />
          <span className="text-xs md:text-sm font-medium text-foreground whitespace-nowrap">
            {badge?.label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default SecurityBadges;